import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 侧边栏是否收起
    sideBarCollapse: Boolean(cookie.get('__content_expanding') === '1'),
    pageContent: null,
    loginCbUrl: '',
    userInfo: null,
    isRefreshApprovalList: false,
    root: false
  },
  mutations: {
    updateLoginCbUrl (state, url) {
      if (!url) return
      state.loginCbUrl = url
    },
    closeSidebar (state) {
      state.sideBarCollapse = false
    },

    openSidebar (state) {
      state.sideBarCollapse = true
    },

    setPageContent (state, ref) {
      state.pageContent = ref
    },

    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    },

    setUserRoot (state, root) {
      state.root = root;
    },
    
    setIsRefreshApprovalList (state, isRefreshApprovalList) {
      state.isRefreshApprovalList = isRefreshApprovalList;
    }
  },
  actions: {

  }
})
